/* Dabi Deri — koleksiyon sayfası denetimi (sections/dabi-collection.liquid)

   - Filtre / sıralama / stok anahtarı / çip kaldırma: sayfa yenilenmeden
     (Section Rendering API) güncellenir, adres çubuğu da güncellenir; geri/ileri çalışır.
   - Masaüstü yan paneli gizle/göster (hatırlanır), telefonda alttan çekmece.
   - Fiyat aralığı: çift kaydırıcı + kutular, yazmayı bitirince uygular.
   - Izgara yoğunluğu (masaüstü 3/4/5, telefon 1/2) hatırlanır.
   - Kart: sepete ekle (tek seçenekli), renk örneğiyle görsel değişimi,
     "imleçle gezin" kipinde fotoğraflar arası geçiş, favori kalbi.
   - Favoriler çekmecesi ve "Son baktıklarınız" (localStorage + /products/x?view=dabi-card).
*/
(() => {
  const FAV_KEY = 'dabi-favs';
  const RECENT_KEY = 'dabi-recent';
  const read = (k) => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } };
  const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* yok */ } };
  const root = window.Shopify?.routes?.root || '/';
  const mqMobile = window.matchMedia('(max-width: 989px)');

  /* ---------- kart parçası (favoriler / son bakılanlar) ---------- */
  const cardCache = new Map();
  const fetchCard = (handle) => {
    if (cardCache.has(handle)) return cardCache.get(handle);
    const req = fetch(`${root}products/${encodeURIComponent(handle)}?view=dabi-card`, { headers: { Accept: 'text/html' } })
      .then((r) => (r.ok ? r.text() : ''))
      .then((t) => (t.includes('data-pcard') ? t : ''))
      .catch(() => '');
    cardCache.set(handle, req);
    return req;
  };

  /* ---------- favoriler: tüm sayfalarda kalp durumu ---------- */
  const syncFavs = (scope = document) => {
    const favs = read(FAV_KEY);
    const i18n = document.querySelector('[data-col-i18n]')?.dataset || {};
    scope.querySelectorAll('[data-pcard]').forEach((card) => {
      const on = favs.includes(card.dataset.handle);
      const b = card.querySelector('[data-pcard-fav]');
      if (!b) return;
      b.setAttribute('aria-pressed', String(on));
      const lbl = on ? i18n.favOn : i18n.favOff;
      if (lbl) { b.setAttribute('aria-label', lbl); b.title = lbl; }
    });
    document.querySelectorAll('[data-col-fav-count]').forEach((el) => {
      el.textContent = String(favs.length);
      el.hidden = favs.length === 0;
    });
  };

  /* ---------- sepete ekle ---------- */
  const addToCart = async (b) => {
    if (b.dataset.state === 'busy') return;
    const i18n = document.querySelector('[data-col-i18n]')?.dataset || {};
    const label = b.querySelector('[data-pcard-label]');
    const set = (st, txt) => { b.dataset.state = st; if (label && txt) label.textContent = txt; };
    set('busy');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = new FormData();
    body.append('id', b.dataset.variant);
    body.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(b);
    }
    try {
      const url = (window.routes && window.routes.cart_add_url) || `${root}cart/add`;
      const res = await fetch(url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      set('done', i18n.added);
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dabi-collection', productVariantId: String(b.dataset.variant), cartData: data });
      }
      if (cart && typeof cart.renderContents === 'function') { cart.classList.remove('is-empty'); cart.renderContents(data); }
      window.setTimeout(() => { if (b.dataset.state === 'done') set('add', i18n.add); }, 2200);
    } catch (err) {
      set('error', i18n.error);
      window.setTimeout(() => { if (b.dataset.state === 'error') set('add', i18n.add); }, 2600);
    }
  };

  /* ---------- kart etkileşimleri (belge geneli; favoriler/son bakılanlarda da çalışır) ---------- */
  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-pcard-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    const fav = e.target.closest('[data-pcard-fav]');
    if (fav) {
      e.preventDefault();
      const handle = fav.closest('[data-pcard]')?.dataset.handle;
      if (!handle) return;
      let favs = read(FAV_KEY);
      favs = favs.includes(handle) ? favs.filter((h) => h !== handle) : [handle, ...favs].slice(0, 60);
      write(FAV_KEY, favs);
      fav.classList.remove('is-pop');
      void fav.offsetWidth;
      fav.classList.add('is-pop');
      syncFavs();
      return;
    }
    const opt = e.target.closest('[data-pcard-options], .dabi-pcard__icon-btn[data-qv-open]');
    if (opt && !document.querySelector('[data-qv-modal]')) { window.location.href = opt.dataset.productUrl; }
  });

  // renk örneği: o rengin fotoğrafını göster
  const swapTo = (sw) => {
    const card = sw.closest('[data-pcard]');
    const img = card?.querySelector('.dabi-pcard__img.is-on, .dabi-pcard__img');
    if (!img || !sw.dataset.pcardSwatch) return;
    if (!img.dataset.orig) { img.dataset.orig = img.currentSrc || img.src; img.dataset.origSet = img.srcset || ''; }
    img.srcset = '';
    img.src = sw.dataset.pcardSwatch;
    card.querySelectorAll('[data-pcard-swatch]').forEach((x) => x.classList.toggle('is-on', x === sw));
  };
  document.addEventListener('pointerover', (e) => { const sw = e.target.closest?.('[data-pcard-swatch]'); if (sw) swapTo(sw); });
  document.addEventListener('focusin', (e) => { const sw = e.target.closest?.('[data-pcard-swatch]'); if (sw) swapTo(sw); });
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.dabi-pcard__swatch');
    if (!sw) return;
    e.preventDefault();
    swapTo(sw);
  });

  // imleçle gezin: görselin genişliği fotoğraf sayısına bölünür
  document.addEventListener('pointermove', (e) => {
    const media = e.target.closest?.('.dabi-pcard--scrub [data-pcard-media]');
    if (!media) return;
    const shots = media.querySelectorAll('.dabi-pcard__img');
    if (shots.length < 2) return;
    if (!media.dataset.warm) { media.dataset.warm = '1'; shots.forEach((s) => { s.loading = 'eager'; }); }
    const r = media.getBoundingClientRect();
    const i = Math.min(shots.length - 1, Math.max(0, Math.floor(((e.clientX - r.left) / r.width) * shots.length)));
    shots.forEach((s, k) => s.classList.toggle('is-on', k === i));
    media.querySelectorAll('.dabi-pcard__dots i').forEach((d, k) => d.classList.toggle('is-on', k === i));
  }, { passive: true });
  document.addEventListener('pointerout', (e) => {
    const media = e.target.closest?.('.dabi-pcard--scrub [data-pcard-media]');
    if (!media || media.contains(e.relatedTarget)) return;
    media.querySelectorAll('.dabi-pcard__img').forEach((s, k) => s.classList.toggle('is-on', k === 0));
    media.querySelectorAll('.dabi-pcard__dots i').forEach((d, k) => d.classList.toggle('is-on', k === 0));
  });

  /* ---------- bölüm ---------- */
  const init = (sec) => {
    if (!sec || sec.dataset.ready === 'true') return;
    sec.dataset.ready = 'true';
    const sid = sec.dataset.sectionId;
    const form = sec.querySelector('[data-col-form]');
    const panel = sec.querySelector('[data-col-filters]');
    const backdrop = sec.querySelector('[data-col-backdrop]');
    const toggle = sec.querySelector('[data-col-filter-toggle]');
    const layout = sec.dataset.layout;
    const HIDE_KEY = `dabi-col-hide:${sid}`;
    let busy = null;

    /* yan panel / çekmece */
    const isDrawer = () => mqMobile.matches || layout === 'drawer';
    const setLabel = () => {
      const l = toggle?.querySelector('.dabi-col__tbtn-label');
      if (!l) return;
      l.textContent = (!isDrawer() && !sec.classList.contains('is-filters-hidden')) ? l.dataset.labelHide : l.dataset.labelShow;
    };
    try {
      const saved = localStorage.getItem(HIDE_KEY);
      if (saved !== null && layout === 'sidebar') sec.classList.toggle('is-filters-hidden', saved === '1');
    } catch (e) { /* yok */ }
    const openDrawer = () => {
      sec.classList.add('is-drawer-open');
      backdrop.hidden = false;
      toggle?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('dabi-col-lock');
      window.setTimeout(() => panel?.focus({ preventScroll: true }), 50);
    };
    const closeDrawer = () => {
      sec.classList.remove('is-drawer-open');
      if (backdrop) backdrop.hidden = true;
      toggle?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('dabi-col-lock');
    };
    toggle?.addEventListener('click', () => {
      if (isDrawer()) { if (sec.classList.contains('is-drawer-open')) closeDrawer(); else openDrawer(); return; }
      const hidden = sec.classList.toggle('is-filters-hidden');
      toggle.setAttribute('aria-expanded', String(!hidden));
      try { localStorage.setItem(HIDE_KEY, hidden ? '1' : '0'); } catch (e) { /* yok */ }
      setLabel();
    });
    sec.querySelectorAll('[data-col-filter-close]').forEach((b) => b.addEventListener('click', closeDrawer));
    backdrop?.addEventListener('click', closeDrawer);
    sec.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sec.classList.contains('is-drawer-open')) { closeDrawer(); toggle?.focus(); } });
    mqMobile.addEventListener?.('change', () => { closeDrawer(); setLabel(); });
    setLabel();

    /* yükle ve bölgeleri değiştir */
    const regions = () => Array.from(sec.querySelectorAll('[data-col-region]'));
    const load = async (href, push = true) => {
      const url = new URL(href, window.location.origin);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', sid);
      if (busy) busy.abort();
      busy = new AbortController();
      sec.classList.add('is-loading');
      try {
        const html = await fetch(fetchUrl, { signal: busy.signal }).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const openGroups = new Set(Array.from(sec.querySelectorAll('.dabi-col__group[open]')).map((d) => d.dataset.colGroup));
        const extraOpen = new Set(Array.from(sec.querySelectorAll('.dabi-col__opts.is-expanded')).map((d) => d.closest('.dabi-col__group')?.dataset.colGroup));
        regions().forEach((el) => {
          const fresh = doc.querySelector(`[data-col-region="${el.dataset.colRegion}"]`);
          if (!fresh) return;
          if (el.dataset.colRegion === 'grid' || el.dataset.colRegion === 'filters' || el.dataset.colRegion === 'active') el.innerHTML = fresh.innerHTML;
          else el.replaceWith(fresh);
        });
        sec.querySelectorAll('.dabi-col__group').forEach((d) => {
          const k = d.dataset.colGroup;
          if (!k) return;
          if (openGroups.has(k)) d.open = true;
          if (extraOpen.has(k)) d.querySelector('.dabi-col__opts')?.classList.add('is-expanded');
        });
        const sortIn = sec.querySelector('[data-col-sort-input]');
        const freshSort = doc.querySelector('[data-col-sort-input]');
        if (sortIn && freshSort) sortIn.value = freshSort.value;
        if (push) window.history.pushState({ dabiCol: true }, '', `${url.pathname}${url.search}`);
        bindPrice();
        syncFavs(sec);
        const tb = sec.querySelector('[data-col-toolbar]');
        if (tb && tb.getBoundingClientRect().top < 0) tb.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (err) {
        if (err.name !== 'AbortError') window.location.assign(url.toString());
      } finally {
        sec.classList.remove('is-loading');
      }
    };

    const submit = () => {
      if (!form) return;
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
      const base = sec.dataset.baseUrl || window.location.pathname;
      load(`${base}?${params.toString()}`);
    };

    form?.addEventListener('change', (e) => {
      if (e.target.matches('[data-col-price-in], [data-col-range]')) return; // fiyat ayrı
      submit();
    });
    form?.addEventListener('submit', (e) => { e.preventDefault(); submit(); });

    /* stok anahtarı → formdaki asıl kutu */
    sec.addEventListener('change', (e) => {
      const m = e.target.closest('[data-col-mirror]');
      if (!m || !form) return;
      const real = form.querySelector(`input[name="${m.dataset.colMirror}"][value="${m.value}"]`);
      if (real) { real.checked = m.checked; submit(); }
      else {
        const params = new URLSearchParams(window.location.search);
        if (m.checked) params.set(m.dataset.colMirror, m.value); else params.delete(m.dataset.colMirror);
        load(`${sec.dataset.baseUrl}?${params}`);
      }
    });

    /* çip / temizle bağlantıları */
    sec.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-col-link]');
      if (!a) return;
      e.preventDefault();
      load(a.href);
    });

    /* daha fazla seçenek */
    sec.addEventListener('click', (e) => {
      const b = e.target.closest('[data-col-more]');
      if (!b) return;
      const list = b.previousElementSibling;
      const on = list.classList.toggle('is-expanded');
      if (!b.dataset.more) b.dataset.more = b.textContent;
      b.textContent = on ? b.dataset.less : b.dataset.more;
    });

    /* fiyat aralığı */
    let priceT = 0;
    function bindPrice() {
      sec.querySelectorAll('[data-col-price]').forEach((box) => {
        if (box.dataset.bound) return;
        box.dataset.bound = '1';
        const max = Number(box.dataset.max) || 0;
        const lo = box.querySelector('[data-col-range="lo"]');
        const hi = box.querySelector('[data-col-range="hi"]');
        const inLo = box.querySelector('[data-col-price-in="lo"]');
        const inHi = box.querySelector('[data-col-price-in="hi"]');
        const fill = box.querySelector('[data-col-range-fill]');
        const paint = () => {
          const a = Number(lo.value);
          const b = Number(hi.value);
          fill.style.left = `${(a / max) * 100}%`;
          fill.style.right = `${100 - (b / max) * 100}%`;
        };
        const later = () => { window.clearTimeout(priceT); priceT = window.setTimeout(submit, 700); };
        lo.addEventListener('input', () => { if (Number(lo.value) > Number(hi.value)) lo.value = hi.value; inLo.value = Number(lo.value) > 0 ? lo.value : ''; paint(); });
        hi.addEventListener('input', () => { if (Number(hi.value) < Number(lo.value)) hi.value = lo.value; inHi.value = Number(hi.value) < max ? hi.value : ''; paint(); });
        [lo, hi].forEach((r) => r.addEventListener('change', later));
        [inLo, inHi].forEach((inp) => inp.addEventListener('input', () => {
          if (inp === inLo) lo.value = inLo.value || 0; else hi.value = inHi.value || max;
          paint();
          later();
        }));
        paint();
      });
    }
    bindPrice();

    /* sıralama menüsü */
    const sort = sec.querySelector('[data-col-sort]');
    if (sort) {
      const btn = sort.querySelector('[data-col-sort-btn]');
      const list = sort.querySelector('[data-col-sort-list]');
      const opts = () => Array.from(list.querySelectorAll('[role="option"]'));
      const openList = () => {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        (opts().find((o) => o.getAttribute('aria-selected') === 'true') || opts()[0])?.focus();
      };
      const closeList = (focusBtn) => { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (focusBtn) btn.focus(); };
      const pick = (o) => {
        opts().forEach((x) => x.setAttribute('aria-selected', String(x === o)));
        const name = sort.querySelector('[data-col-sort-name]');
        if (name) name.textContent = o.textContent.trim();
        const input = sec.querySelector('[data-col-sort-input]');
        closeList(true);
        if (input) { input.value = o.dataset.value; submit(); }
        else {
          const params = new URLSearchParams(window.location.search);
          params.set('sort_by', o.dataset.value);
          load(`${sec.dataset.baseUrl}?${params}`);
        }
      };
      btn.addEventListener('click', () => (list.hidden ? openList() : closeList()));
      list.addEventListener('click', (e) => { const o = e.target.closest('[role="option"]'); if (o) pick(o); });
      list.addEventListener('keydown', (e) => {
        const all = opts();
        const i = all.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); all[Math.min(all.length - 1, i + 1)]?.focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); all[Math.max(0, i - 1)]?.focus(); }
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (all[i]) pick(all[i]); }
        if (e.key === 'Escape' || e.key === 'Tab') closeList(e.key === 'Escape');
      });
      document.addEventListener('click', (e) => { if (!sort.contains(e.target) && !list.hidden) closeList(); });
    }

    /* ızgara yoğunluğu */
    const dens = sec.querySelector('[data-col-density]');
    if (dens) {
      const KD = 'dabi-col-cols';
      const KM = 'dabi-col-cols-m';
      const apply = () => {
        let d = null;
        let m = null;
        try { d = localStorage.getItem(KD); m = localStorage.getItem(KM); } catch (e) { /* yok */ }
        if (d) sec.style.setProperty('--dc-cols', d);
        if (m) sec.style.setProperty('--dc-cols-m', m);
        const cd = getComputedStyle(sec).getPropertyValue('--dc-cols').trim();
        const cm = getComputedStyle(sec).getPropertyValue('--dc-cols-m').trim();
        dens.querySelectorAll('[data-cols]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cols === cd)));
        dens.querySelectorAll('[data-cols-m]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.colsM === cm)));
      };
      dens.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b) return;
        try {
          if (b.dataset.cols) localStorage.setItem(KD, b.dataset.cols);
          if (b.dataset.colsM) localStorage.setItem(KM, b.dataset.colsM);
        } catch (err) { /* yok */ }
        if (b.dataset.cols) sec.style.setProperty('--dc-cols', b.dataset.cols);
        if (b.dataset.colsM) sec.style.setProperty('--dc-cols-m', b.dataset.colsM);
        apply();
      });
      apply();
    }

    /* açıklama: devamını oku */
    const desc = sec.querySelector('[data-col-desc]');
    if (desc) {
      const body = desc.querySelector('.dabi-col__desc-body');
      const btn = desc.querySelector('[data-col-desc-toggle]');
      if (body.scrollHeight <= body.clientHeight + 8) { btn.hidden = true; desc.classList.add('is-open'); }
      btn.addEventListener('click', () => {
        const on = desc.classList.toggle('is-open');
        if (!btn.dataset.more) btn.dataset.more = btn.textContent;
        btn.textContent = on ? btn.dataset.less : btn.dataset.more;
      });
    }

    /* favoriler çekmecesi */
    const favBtn = sec.querySelector('[data-col-favs]');
    const favDrawer = sec.querySelector('[data-col-favs-drawer]');
    if (favBtn && favDrawer) {
      const list = favDrawer.querySelector('[data-col-favs-list]');
      const render = async () => {
        const favs = read(FAV_KEY);
        if (favs.length === 0) { list.innerHTML = `<p class="dabi-col__favs-empty">${list.dataset.empty}</p>`; return; }
        list.innerHTML = '<div class="dabi-col__favs-grid"></div>';
        const grid = list.firstElementChild;
        const parts = await Promise.all(favs.map(fetchCard));
        grid.innerHTML = parts.join('');
        syncFavs(grid);
      };
      const openFavs = () => { favDrawer.hidden = false; document.documentElement.classList.add('dabi-col-lock'); render(); favDrawer.querySelector('[data-col-favs-close]')?.focus(); };
      const closeFavs = () => { favDrawer.hidden = true; document.documentElement.classList.remove('dabi-col-lock'); favBtn.focus(); };
      favBtn.addEventListener('click', openFavs);
      favDrawer.addEventListener('click', (e) => { if (e.target === favDrawer || e.target.closest('[data-col-favs-close]')) closeFavs(); });
      favDrawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeFavs(); });
      favDrawer.addEventListener('click', (e) => { if (e.target.closest('[data-pcard-fav]')) window.setTimeout(render, 250); });
    }

    /* son baktıklarınız */
    const recent = sec.querySelector('[data-col-recent]');
    if (recent) {
      const list = recent.querySelector('[data-col-recent-list]');
      const max = Number(recent.dataset.max) || 10;
      const items = read(RECENT_KEY).slice(0, max);
      if (items.length > 0) {
        Promise.all(items.map(fetchCard)).then((parts) => {
          const html = parts.filter(Boolean).map((p) => `<li>${p}</li>`).join('');
          if (!html) return;
          list.innerHTML = html;
          recent.hidden = false;
          syncFavs(list);
          window.DabiStrips?.init(recent);
        });
      }
      recent.querySelector('[data-col-recent-clear]')?.addEventListener('click', () => { write(RECENT_KEY, []); recent.hidden = true; list.innerHTML = ''; });
    }

    /* sayfalayıcı yeni kart eklediğinde kalp durumları */
    const gridHost = sec.querySelector('#ProductGridContainer');
    if (gridHost) new MutationObserver(() => syncFavs(gridHost)).observe(gridHost, { childList: true, subtree: true });
    syncFavs();

    window.addEventListener('popstate', () => { if (document.body.contains(sec)) load(window.location.href, false); });
  };

  const boot = () => document.querySelectorAll('[data-dabi-col]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const s = e.target.querySelector('[data-dabi-col]'); if (s) init(s); });
  window.DabiFavs = { sync: syncFavs };
})();
